import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import Header from '../../components/Header';
import Home from './Home';
import Join from './Join';
import GetStarted from './GetStarted';
import Tour from './Tour';
import CourseInfo from './CourseInfo';
import Courses from './Courses';
import Contact from './Contact';
import Competition from './Competition';
import Hiring from './Hiring';
import About from './About';
import Terms from './Terms';
import Requirements from './Requirements';
import Privacy from './Privacy';
import Footer from '../../components/Footer';
import Error404 from './Error404';
// import NotificationsBar from '../../components/NotificationsBar';
import Stripe from './Stripe.js';
import graphql from '../../helpers/graphql';

class Main extends Component {
  constructor (props) {
    super(props);
    this.state = {
      courses: [],
      detailsShow: false
    };
    graphql.getCourses().then((response) => {
      this.setState({
        courses: response.courses
      });
    });
  }

  render () {
    return (
      <span>
        <Header />

        <Switch>
        <Route path='/stripe' component={Stripe} />
          <Route path='/tour' component={Tour} />
          <Route path='/course-info' component={CourseInfo} />
          <Route path='/courses' render={() => {
            return <Courses courses={this.state.courses} />;
          }} />
          <Route exact path='/contact' component={Contact} />
          <Route exact path='/competition' component={Competition} />
          <Route exact path='/hiring' component={Hiring} />
          <Route exact path='/about' component={About} />
          <Route exact path='/terms' component={Terms} />
          <Route exact path='/requirements' component={Requirements} />
          <Route exact path='/privacy' component={Privacy} />
          <Route exact path='/join' component={Join} />
          <Route exact path='/get-started' component={GetStarted} />
          <Route exact path='/' render={() => {
            return <Home courses={this.state.courses} />;
          }} />
          <Route exact path='/course-picker' render={() => {
            return <Home courses={this.state.courses} />;
          }} />
          <Route exact path='/error404' component={Error404} />
          <Route component={Error404} />
        </Switch>
        <Footer courses={this.state.courses} />
      </span>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/views/Main/index.js